import { useLocation } from "react-router-dom";
import useAppState from "../../context/AppContext";
import { useState } from "react";
import AdditionalOptionModal from "../../modals/common/AdditionalOptionModal";
import HelpAndContactModal from "../../modals/common/HelpAndContactModal";
import NavbarBloc from "./NavbarBloc";
import { isMobile } from "../../utils/utils";
import MgpProgressbarWithSteps from "../../components/common/MgpProgressbarWithSteps";
import MgpProgressBar from "../../elements/MgpProgressBar/MgpProgressBar";
import MgpRetirementProgressbarWithSteps from "../../components/common/MgpRetirementProgressbarWithSteps";


export default function HeaderBloc() {
  const {
    state: { infoSteps, showModal, isConseiller, isRetired },
  } = useAppState();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openContactModal, setOpenContactModal] = useState<boolean>(false);

  const currentLocation = useLocation();

  let percentage = infoSteps.find(step => step.path === currentLocation.pathname)?.percentage;
  if (isMobile()) {
    if (infoSteps.find(step => step.path === currentLocation.pathname)?.category === "PERSONAL") {
      percentage = "25%";
    } else if (infoSteps.find(step => step.path === currentLocation.pathname)?.category === "BENEFICIARY") {
      percentage = "50%";
    } else if (infoSteps.find(step => step.path === currentLocation.pathname)?.category === "GUARANTY") {
      percentage = "75%";
    } else {
      percentage = "100%"
    }
  }


  if (isRetired) {
    return (
      <header className="entreprise-header bg-bleu shadow-bleu">
        <MgpRetirementProgressbarWithSteps />
      </header>
    )
  }

  return (
    <header className="entreprise-header bg-bleu shadow-bleu">

        {
          !isConseiller && !showModal && <div className="" style ={{height: "100%", width: "100%"}}>
            {isMobile() ? <div><NavbarBloc /></div> : <div className="mt-sm"><MgpProgressbarWithSteps /></div>}
          </div>
        }

        {
          isConseiller && isMobile() && 
          <div style ={{height: "100px", width: "100%"}}>

          </div>
        }
        <div className='progressbar'>
          {isMobile() && percentage && !showModal && !isConseiller && <MgpProgressBar percentage={percentage} />}
        </div>

        {isOpen && <AdditionalOptionModal isOpen={isOpen} onCloseModal={() => setIsOpen(false)}/>}
        {openContactModal && <HelpAndContactModal isOpen={openContactModal} onCloseModal={() => setOpenContactModal(false)} />}
     
  </header>
  )
}